import type { Special } from "@/types/article";

export const specials: Special[] = [
  {
    id: "spring-2024-blackwave",
    title: "2024 春季黑丝潮流速递",
    subtitle: "BLACK TIGHTS · SPRING REPORT",
    intro: "本季黑丝强势回潮，从哑光材质到运动混搭，我们梳理出最值得关注的五个方向，帮你用一双黑丝穿出整个春天的态度。",
    cover: "https://readdy.ai/api/search-image?query=Spring%20fashion%20editorial%20banner%20of%20a%20model%20in%20black%20sheer%20tights%20with%20a%20light%20flowing%20outfit%20against%20a%20soft%20neutral%20gradient%20backdrop%20with%20airy%20elegant%20lighting%20and%20refined%20tones&width=1600&height=900&seq=hei-sp-01&orientation=landscape",
    groups: [
      {
        title: "趋势速览",
        reason: "三分钟了解本季黑丝风向，快速建立时尚感知。",
        articleIds: ["2024-spring-trends", "runway-black-tights", "celebrity-black-tights"],
      },
      {
        title: "春日实穿搭配",
        reason: "好看又好穿，把这些组合复制进日常衣橱。",
        articleIds: ["black-tights-street-style", "sneakers-with-tights", "black-tights-denim-look"],
      },
    ],
  },
  {
    id: "office-elegance",
    title: "职场黑丝优雅指南",
    subtitle: "OFFICE · ELEGANCE EDIT",
    intro: "办公室里的黑丝讲究分寸感。这个专题从厚度、配色到场合拿捏，帮你在专业与魅力之间找到那个刚刚好的平衡点。",
    cover: "https://readdy.ai/api/search-image?query=Office%20elegance%20fashion%20editorial%20banner%20of%20a%20businesswoman%20in%20opaque%20black%20tights%20and%20a%20tailored%20grey%20suit%20in%20a%20bright%20modern%20workspace%20with%20clean%20neutral%20tones%20and%20soft%20daylight&width=1600&height=900&seq=hei-sp-02&orientation=landscape",
    groups: [
      {
        title: "通勤必修课",
        reason: "基础且高效的职场穿搭方法，一次学会。",
        articleIds: ["office-black-tights-guide", "coat-and-tights", "sheer-vs-opaque-black"],
      },
      {
        title: "身形与自信",
        reason: "不同身形都能找到合适的优雅方案。",
        articleIds: ["plus-size-tights", "tights-color-match", "layering-socks-secrets"],
      },
    ],
  },
  {
    id: "party-night",
    title: "派对季黑丝闪耀特辑",
    subtitle: "PARTY · NIGHT SHINE",
    intro: "灯光亮起的时刻，一条恰到好处的黑丝就是最好的入场券。从光泽拿捏到配色主线，让每一次登场都值得被记住。",
    cover: "https://readdy.ai/api/search-image?query=Glamorous%20party%20fashion%20editorial%20banner%20of%20a%20woman%20in%20black%20shiny%20tights%20with%20an%20elegant%20dress%20among%20warm%20festive%20bokeh%20lights%20with%20rich%20dark%20luxurious%20tones&width=1600&height=900&seq=hei-sp-03&orientation=landscape",
    groups: [
      {
        title: "闪耀登场",
        reason: "让黑丝成为夜晚造型的高光时刻。",
        articleIds: ["party-season-tights", "evening-black-tights-elegance", "runway-black-tights"],
      },
      {
        title: "细节加分",
        reason: "从保养到配色，让造型从头到尾都在线。",
        articleIds: ["care-and-durability", "tights-color-match", "2024-spring-trends"],
      },
    ],
  },
];

export const getSpecialById = (id: string): Special | undefined => {
  return specials.find((item) => item.id === id);
};